import mixpanel from 'mixpanel-browser';
// mixpanel.init('1d6d50c800587dafcd73c02519d796c7', { debug: false, persistence: 'localStorage' }); // production
mixpanel.init('83c4d13d9f3d2b65bfd194589e3b0927', { debug: true, persistence: 'localStorage' }); // development

let env_check = process.env.NODE_ENV === 'production';

let actions = {
  identify: (id) => {
    mixpanel.identify(id);
  },
  alias: (id) => {
    mixpanel.alias(id);
  },
  track: (name, props) => {
    mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;